import axiosInstance from "services/common/axiosInstance";

export interface ImportExcelFileParams {
  file_url: string;
}

export interface ImportExcelFileResponse {
  success: boolean;
  message?: string;
  data?: unknown;
}

export const importExcelFile = async (
  params: ImportExcelFileParams
): Promise<ImportExcelFileResponse> => {
  const { data } = await axiosInstance.post<ImportExcelFileResponse>(
    "/lic/importexcelfile",
    params,
    { timeout: 600000 }
  );
  return data;
};

export const uploadBulkExcel = async (
  file: File
): Promise<ImportExcelFileResponse> => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await axiosInstance.post<ImportExcelFileResponse>(
    "/lic/uploadbulkexcel",
    formData
  );
  return data;
};

export interface DistributorMappingParams {
  proposal_ids: number[];
  consultant_code: string;
  consultant_name: string;
}

export const distributorMapping = async (
  params: DistributorMappingParams
): Promise<ImportExcelFileResponse> => {
  const { data } = await axiosInstance.post<ImportExcelFileResponse>(
    "/lic/distributormapping",
    params
  );
  return data;
};
